import { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";

const TestPage = () => {
    const [data, setData] = useState<any>();
    useEffect(() => {
        loadData().then(setData).catch((error) => console.log(error));
    }, []);

    async function loadData() {

    }

    return <>
        <Container>
            <Row>
                <Col>
                    <Card className="card-widget">
                        <Card.Header>Test Page</Card.Header>
                        <Card.Body>
                            {!data ? <>Loading...</> : <>
                                <pre>{JSON.stringify(data, null, 2)}</pre>
                            </>}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </>
}

export default TestPage;